var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6 4.3c-.2-.4-.6-.7-1-.8-.5-.1-1 0-1.3.2-.6.3-1 .9-1.4 1.4a15 15 0 0 0-1.6 2.8 22.5 22.5 0 0 0-1.6 5c-.8-.5-1.3-.9-1.6-1.4l-.7-1.8s-.4-1.2-1-1.4c-.6-.3-1.3-.1-1.8.3a13.8 13.8 0 0 0-3.3 9c0 2.9 1.1 5.7 3.3 7.8a11.8 11.8 0 0 0 16.2 0c2.2-2.1 3.3-5 3.3-7.7 0-2.8-1-5.8-3.3-8a19 19 0 0 1-4.2-5.4Zm-4.8 18.4v-1.3h-4.2v-1.7h3.6v-1.4h-3.6v-1.5h4v-1.4H10v7.3h5.9Zm.5-7.3H18v7.3h-1.7v-7.3Zm5.3 7.3h2l-1.7-2.3c.5-.2.9-.5 1.1-1 .3-.3.4-.8.4-1.3 0-.6-.1-1-.4-1.5-.2-.4-.6-.7-1.1-.9-.5-.2-1.1-.3-1.8-.3h-1.4v1.4H20c.5 0 1 0 1.2.3.3.2.4.5.4 1 0 .4-.1.7-.4.9-.2.2-.7.3-1.2.3h-1.3v1.4H20l1.5 2Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireActive);
export default __webpack_public_path__ + "static/media/fire-active.65a2a04e5b5b6db686443b7fa0d5aca6.svg";
export { ForwardRef as ReactComponent };